import { defineStore } from 'pinia';
import type {
  IChatMessage,
  IChatSession
} from '@rready/components/src/chat/chatTypes';

export const useChatStore = defineStore('chat', {
  state: () => ({
    sessionData: [] as IChatSession[]
  }),
  actions: {
    createSession(session: IChatSession): IChatSession {
      if (this.sessionData.find((it) => it.key === session.key)) {
        throw new Error(`Could not create chat session [key=${session.key}]`);
      } else {
        this.sessionData.push(session);
        return session;
      }
    },
    hasSession(sessionId: string): boolean {
      return !!this.sessionData.find((it) => it.key === sessionId);
    },
    loadSession(sessionId: string): IChatSession {
      const session = this.sessionData.find((it) => it.key === sessionId);
      if (!session) {
        throw new Error(`Could not find chat session [key=${sessionId}]`);
      }
      return session;
    },
    pushMessage(sessionId: string, message: IChatMessage): void {
      this.loadSession(sessionId)?.messages?.push(message);
    }
  }
});
